"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var baseColors_v2 = {
  atomic: '#444F5C',
  aliceBlue: '#EBF4FF',
  black: '#161616',
  glitter: '#EDEEF0',
  persianGreen: '#00B39B'
};
var _default = baseColors_v2;
exports["default"] = _default;